import {showError} from '../error';
import {endpoint} from '../../../auth_config.json';


const ToolsStore = {
  namespaced: true,

  state: {
    items: [],
    loading: false
  },

  mutations: {
    setItems(state, items) {
      state.items = items;
    },

    deleteItem(state, item) {
      state.items = state.items.filter((itm) => itm.id !== item.id);
    }
  },


  actions: {
    // eslint-disable-next-line no-unused-vars
    async getTools({commit}, payload) {
      const parameters = {
        providerId: payload.providerId,
        channelId: payload.channelId
      };
      try {
        // eslint-disable-next-line no-undef
        const response = await api.call(this, commit, 'CampaignsList', parameters);
        commit('setCampaigns', response.data.results || []);
      } catch (error) {
        showError(error, 'getTools');
      }
    },
    async deleteToolItem({commit}, payload) {
      const parameters = {
        providerId: payload.providerId,
        channelId: payload.channelId
      };
      try {
        // eslint-disable-next-line no-undef
        const response = await api.call(this, commit, 'CampaignsList', parameters);
        commit('setCampaigns', response.data.results || []);
      } catch (error) {
        showError(error, 'deleteToolItem');
      }
    }
  },

  getters: {
    getItems(state) {
      return state.items;
    }
  }
};

export default ToolsStore;
